/**
* @Author: zachalam
* @Date:   2017-01-23T16:03:15-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-24T11:47:06-08:00
*/

import axios from 'axios';
import MasterConfig from './config/Master';
import { browserHistory } from 'react-router';
import { extractLocationData, objectToUrl, objectToQueryString, cleanObject, stripHeightMaxes } from './common';
import qs from 'qs';
import { toast } from 'react-toastify';
import _ from 'lodash';
import store from './store';
import { refreshUserToken, storeHttpRequest, removeStaleHttpRequests, removeHttpRequest } from './actions/authActions';
import { showTOS } from './actions/profileActions';
import { findIndex } from 'lodash';

// check for PRODUCTION defined api, if so use that instead.
var api = MasterConfig.api;
var per_page = MasterConfig.per_page;


axios.interceptors.request.use((config) => {

   if(config.url.indexOf("auth/refresh") > 0) { return config; }

   return store.dispatch(removeStaleHttpRequests()).then(() => {

     // store open http requests
     let httprequest = config.method + config.url;
     let activeHttp = findIndex(store.getState().auth.requestList, (v) => { return v.loc === httprequest.toLowerCase() });

     if(activeHttp === -1) {
      return store.dispatch(storeHttpRequest(httprequest)).then(() => {
        return config;
      });
    } else {
      // active request open - block this one.
      console.log("REQUEST BLOCKED");
      Promise.reject(config);
    }
    }).catch(error => {
       return Promise.reject(error);

    });

}, (error) => {
  return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
  // no issue, just return the normal response.
  store.dispatch(removeHttpRequest(response.config.method + response.config.url));
  return response;

  }, (error) => {

    let login = error.response.request.responseURL.indexOf("auth/login");
    if((error.response.status === 401)) {
      // attempt to get a new token if the user is authenticated...
      // the API said the user was authenticated, if they were previously
      // authenticated attempt to refresh their token.
      if(store.getState().auth.isAuthenticated) {
        // if this action fails user will be logged out.
        // otherwise, the subsequent requests will be processed.
        store.dispatch(refreshUserToken());
      } else {
        // log user out if this 401 did not occur on the login page.
        if(!login) browserHistory.push("/logout")
      }



    }

    else if(error.response.status === 404) {
      browserHistory.replace("/404");
    }

    else if(error.response.status === 422){
      //console.log("generic error");
      toast.warn('There was an error submitting the form.');
    } else if(error.response.status === 451) {
      store.dispatch(showTOS());
    } else {
      toast.warn('Uh Oh! Something went wrong.');
    }
    return Promise.reject(error);
});

// ---------------------------

const config = (authRequired) => {

  let token = authRequired ? store.getState().auth.jwToken : '';
  return ({
    headers: {
    'Authorization':  'Bearer ' + token,
    'Accept':         'application/json'
    }
  });
};


/**
  Creates new account
  @param email
  @param username
  @param password
  @param promo
**/
export function createUserAccount(email,username,password,password_confirm,
  agreements,promo,ref,referral,radio_code) {
  return axios.post(
    `${api}/account`, {
      email,
      username,
      password,
      password_confirm,
      agreements,
      promo,
      ref,
      referral,
      radio_code
    }, config());
}




export function resendEmail(token) {
  return axios({
    method: 'GET',
    url: `${api}/account/resend_activation`,
    data: {},
    ...config(token)
  });
}


/**
  Creates new profile
**/
export function createUserProfile(token,formData) {
  let { sex, interested, year, month, day, location } = formData;
  location = extractLocationData(location);

  return axios.post(
    `${api}/profile`, {
      sex, interested, year, month, day, ...location
    }, config(token));
}


/**
  Retrieves JWToken
  @param login
  @param password
**/
export function getAuthToken(login,password) {
  return axios.post(
    `${api}/auth/login`,{login,password}, config());
};

/**
  Retrueves NEW JWToken
  @param token - the old token
**/
export function getNewAuthToken(token) {
  return axios({
    method: 'GET',
    url: `${api}/auth/refresh`,
    data: {},
    ...config(true)
  });
}

/**
  Kills JWToken in header
  @param none
**/
export function killAuthToken(token) {
  return axios.post(
    `${api}/auth/logout`, null, config(token));
}

/**
  Send password reminder
  @param email
**/
export function requestPassReminder(email) {
  return axios({
    method: 'post',
    url: `${api}/forgot/password`,
    data: {email}
  })
}

export function setNewPassword(formData) {
  return axios({
    method: 'POST',
    url: `${api}/reset/password`,
    data: formData
  })
}


/**
  Retrieve logged in profile (and all their trips).
**/
export function getLoggedProfile(token) {
  return axios({
    method: 'get',
    url: `${api}/auth/user?include=profile,trip,photo`,
    data: {},
    ...config(token)
  });
}

/**
  Get logged account information
**/
export function getLoggedAccount(token) {
  return axios({
    method: 'GET',
    url: `${api}/auth/user`,
    data: {},
    ...config(token)
  });
}

/**
  Updates account profile
  @param formData "height", "body_type", "children", etc...
**/
export function updateLoggedProfile(token,formData) {
  return axios({
    method: 'put',
    url: `${api}/profile`,
    data: formData,
    ...config(token)
  })
}


/**
  Retrieves favorites for a logged in user
  @param - type: 'from' or 'to'
  'from' is users that favorited the logged in user.
**/
export function getFavorites(token,type,page=1,per_page) {
  let numberToGet = per_page === 0 ? MasterConfig.per_page : per_page
  return axios({
    method: 'get',
    url: `${api}/favorite/${type}?include=other_account.profile&page=${page}&per_page=${numberToGet}`,
    data: {},
    ...config(token)
  });
}

/**
  Toggles favorite for a given profileId
**/
export function toggleFavorite(token,profileId) {
  return axios({
    method: 'put',
    url: `${api}/favorite/${profileId}`,
    data: {},
    ...config(token)
  });
}

/**
  Gets profiels that viewed the logged in user.
**/
export function getVisitedMe(token,page=1) {
  return axios({
    method: 'get',
    url: `${api}/profile_view?include=other_account.profile&page=${page}&per_page=${per_page}`,
    data: {},
    ...config(token)
  })
}

/**
  Retrieve Mail threads from server
  @param - type: 'sentbox' or 'inbox'
**/
export function getMailList(token,type,page=1,per_page=0) {
  // use default per_page if it's set to 0.
  //console.log("incoming per_page", per_page);
  let numberToGet = per_page === 0 ? MasterConfig.per_page : per_page
  return axios({
    method: 'get',
    url: `${api}/thread/${type}?include=other_profile.account&page=${page}&per_page=${numberToGet}`,
    data: {},
    ...config(token)
  });
}


/**
  Retrieve Messages in a specific mail conversaion
  @param - username (ie: walter)
**/
export function getMailConvo(token,username) {
  return axios({
    method: 'get',
    url: `${api}/thread/${username}?include=account,photo`,
    data: {},
    ...config(token)
  });
}

/**
  Post a message to a mail conversation
  @param - username (ie: zoomm)
  @param - message (ie: "hello how are you?")
**/
export function postMailConvo(token,username,message) {
  return axios({
    method: 'post',
    url: `${api}/message`,
    data: {username, message},
    ...config(token)
  });
}

/**
  Delete a message to a mail conversation
  @param - username (ie: zoomm)
**/
export function deleteMailThread(token,username) {
  return axios({
    method: 'DELETE',
    url: `${api}/thread/${username}`,
    data: {},
    ...config(token)
  });
}

/**
  Retrieve Users who liked a trip
  @param - tripID: 1 (int)
**/
export function getTripLikeList(token,tripID,page=1,per_page=0) {
  let numberToGet = per_page === 0 ? MasterConfig.per_page : per_page
  return axios({
    method: 'get',
    url: `${api}/trip/${tripID}/likes?include=other_account.profile&page=${page}&per_page=${numberToGet}`,
    data: {},
    ...config(token)
  });
}

/**
 * Retrieve a Trip based off the ID so show when a User it viewing the trip
 * @param {String} token JWT used to ensure that the user is authenticated
 * @param {Number} tripID ID of the trip to request
 */
export function getTrip(token,tripID) {
  return axios({
    method: 'get',
    url: `${api}/trip/${tripID}?include=profile.account`,
    data: {},
    ...config(token)
  });
}
/**
  Ask to join/like trip
  @param - tripID: 1 (int)
**/
export function askToJoinTrip(token,tripID) {
  return axios({
    method: 'PUT',
    url: `${api}/trip_like/${tripID}`,
    data: {},
    ...config(token)
  });
}

/**
  Craetes a new trip
  @param - formData (who_pays, title, etc..)
**/
export function createNewTrip(token,formData) {
  return axios({
    method: 'post',
    url: `${api}/trip`,
    data: formData,
    ...config(token)
  });
}

/**
  Cancels an existing trip
  @param - tripId
**/
export function cancelTrip(token,tripId,reason) {
  return axios({
    method: 'DELETE',
    url: `${api}/trip/${tripId}`,
    data: {reason},
    ...config(token)
  });
}

/**
  Retrieves an external profile
  @param - username: (ie: skyler)
**/
export function getExternalProfile(token,username) {
  username = username.toLowerCase();
  return axios({
    method: 'get',
    url: `${api}/account/${username}?include=profile,trip,photo`,
    data: {},
    ...config(token)
  });
}

/**
  Get account settings
**/
export function getAccountSettings(token) {
  return axios({
    method: 'get',
    url: `${api}/settings`,
    data: {},
    ...config(token)
  });
}


/**
  Deactivate account
  @param password
**/
export function deactivateAccount(token,password) {
  return axios({
    method: 'put',
    url: `${api}/account/deactivate`,
    data: {password},
    ...config(token)
  });
}


/**
  Update account settings
  @param: formData "hidden", "hidden_blocked", "hidden_favorite", etc..
**/
export function updateAccountSettings(token, formData) {
  return axios({
    method: 'put',
    url: `${api}/settings`,
    data: formData,
    ...config(token)
  });
}

/**
  Gets a list of blocked users
**/
export function getBlockedList(token, page, per_page) {
  console.log(page, per_page);
  return axios({
    method: 'get',
    url: `${api}/block?include=to_account,to_account.profile&page=${page}&per_page=${per_page}`,
    ...config(token)
  })
}

/**
  Block a specific user.
**/
export function blockUser(token, username) {
  return axios({
    method: "PUT",
    url: `${api}/block/${username}`,
    data: {},
    ...config(token)
  })
}

/**
  Update account password
  @param formData: {old_password, password, new_password}
**/
export function updateAccountPassword(token, formData) {
  return axios({
    method: 'put',
    url: `${api}/account`,
    data: formData,
    ...config(token)
  });
}

/**
  Updates account email
  @param formData: {password, email}
**/
export function updateAccountEmail(token, formData) {
  return axios({
    method: 'put',
    url: `${api}/settings/email`,
    data: formData,
    ...config(token)
  });
}


/**
  Billing: Pull available packages from API.
  @param none
**/
export function getBillingPackages(token) {
  return axios({
    method: 'get',
    url: `${api}/payment/packages`,
    data: {},
    ...config(token)
  })
}

/**
  Billing: Make payment to API.
  @param: formData (use2pay..)
**/
export function postBillingPayment(token,formData) {
  return axios({
    method: 'post',
    url: `${api}/payment`,
    data: formData,
    ...config(token)
  })
}

/**
  Billing: Get list of payments.
  @param: none
**/
export function getBillingPayments(token) {
  return axios({
    method: 'GET',
    url: `${api}/payment`,
    data: {},
    ...config(token)
  })
}


/**
  Billing: cancel active subscription
  @param: none
**/
export function deleteActiveSubscription(token) {
  return axios({
    method: 'DELETE',
    url: `${api}/subscription`,
    data: {},
    ...config(token)
  })
}

/**
  Billing: get most recent
**/
export function getRecentSubscription(token) {
  return axios({
    method: 'GET',
    url: `${api}/subscription/active`,
    data: {},
    ...config(token)
  })
}


/**
  Photo Uploader
  @param formData { photo, private }
**/
export function postNewPhoto(token,formData) {
  return axios({
    method: 'POST',
    url: `${api}/photo`,
    data: formData,
    ...config(token)
  })
}

/**
  Delete photo
  @param photoId
**/
export function deletePhoto(token,photoId) {
  return axios({
    method: 'DELETE',
    url: `${api}/photo/${photoId}`,
    data: {},
    ...config(token)
  })
}

/**
  switches Photo permission
  @param photoId
**/
export function putPhotoPrivacy(token,photoId) {
  return axios({
    method: 'PUT',
    url: `${api}/photo/${photoId}`,
    data: {},
    ...config(token)
  })
}

/**
  Makes photo your default
  @param photoId
**/
export function putPhotoAvatar(token,photoId) {
  return axios({
    method: 'PUT',
    url: `${api}/photo/avatar`,
    data: {id: photoId},
    ...config(token)
  })
}


/**
  Searches profiles
  @param formData
**/
export function profileSearch(token,formData,page=1) {
  //console.log("data gotten");
  //console.log(formData);
  // omit empty formData values.
  let newFormData = cleanObject(formData);
  // strip leaving and returning object vars
  let data = {include: 'account', page, per_page, ...newFormData, leaving: '', returning: ''};
  data = stripHeightMaxes(data);

  return axios({
    method: 'GET',
    url: `${api}/profile?${qs.stringify(data)}`,
    ...config(token)
  })

}

/**
  Searches trips
  @param formData
**/
export function tripSearch(token,formData,page=1) {
  // omit empty formData values.
  let newFormData = cleanObject(formData);
  // strip leaving and returning object vars
  let data = {include: 'account,account.profile', page, per_page, ...newFormData, leaving: '', returning: ''};
  data = stripHeightMaxes(data);

  return axios({
    method: 'GET',
    url: `${api}/trip?${qs.stringify(data)}`,
    ...config(token)
  })
}

/**
 * Return all the tags for Trip Create.
 */
export function getAllTags(token) {
  return axios({
    method: 'GET',
    url: `${api}/tag`,
    ...config(token)
  })
}

/**
  Makes photo your default
  @param formData (reason_type,message,account)
**/
export function reportUser(token,formData) {
  return axios({
    method: 'POST',
    url: `${api}/report`,
    data: formData,
    ...config(token)
  })
}

/**
 * Return a Trip Destination Photo based on the Lat and Lng that are passed in.
 * @param {string} lat - Latitude returned from places
 * @param {string} lng - Longitude returned from places
 */
export function getDestinationPhoto(token, lat, lng) {
  return axios({
    method: 'GET',
    url: `${api}/whereabout/${lat}/${lng}`,
    ...config(token)
  })
}

/**
 * Request for a GDPR Deletion
 * @param token - Auth Token
 * @param formData - {password, account}
 */
export function requestGdprDeletion(token, formData) {
  return axios({
    method: 'DELETE',
    url: `${api}/gdpr`,
    ...config(token),
    data: formData
  });
}

/**
 * Request for GDPR information
 * @param token - Auth Token
 * @param formData - {password, account}
 */
export function requestGdprInformation(token, formData) {
  return axios({
    method: 'POST',
    url: `${api}/gdpr`,
    ...config(token),
    data: formData
  });
}

/**
 * Accept TOS
 * @param token - Auth Token
 * @param tos_version - version of the TOS to accept
 **/
export function acceptTos(token, tos_version) {
  return axios({
    method: 'POST',
    url: `${api}/tos`,
    ...config(token),
    data: {tos_version}
  })
};

/**
 * Get the TOS
 * @param token - Auth token
 **/
export function getTos(token) {
  return axios({
    method: 'GET',
    url: `${api}/tos`,
    ...config(token),
  })
};

/**
 * Get the Privacy Policy
 * @param token - Auth token
 **/
export function getPrivacyPolicy(token) {
  return axios({
    method: 'GET',
    url: `${api}/public/privacy_policy`,
    ...config(token),
  })
};



// WEBPACK FOOTER //
// ./src/sdk.js